define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml"
], function(declare, csi, Controller, image, reflection, xml) {

	return declare(Controller, {
		toWriter: function() {
			// summary: remove image from map
			const {widget} = this;
			const {imageSpec} = widget;
			var node = this.getNode();
			var a = this.m_action;
			var value = a.getImageValue(node);
			var cn = this.m_writer.changeNode(this.m_urlNode);

			if (imageSpec.type == xml.ATTR_REF) {
				cn.changeAttribute(a.idAttr, xml.ATTR_REF, csi.EMPTY_URL);
				return;
			}

			var keyDefault = reflection.DEFAULT_IMAGE_LABEL;
			var key = widget.getCurrentImageKey();
			var url = value[key];
			var keysRemove = [];
			var bDefault = false;

			// find keys that point to image
			csi.applyForEach(value, function(v, k) {
				if (v == url) {
					if (k == keyDefault) {
						bDefault = true;
					}

					keysRemove.push(k);
				}
			});

			if (xml.nodeAttributeHasExpression(node, a.idAttr)) {
				cn.disableAttributeExp(a.idAttr);
			}

			// remove keys from map pointing to image
			if (keysRemove.length) {
				cn.removeAttributeKeys(a.idAttr, xml.ATTR_REFMAP, keysRemove);
			}

			// default image was removed, so replace with next numbered key
			var keys = image.getNumberedKeys(value, false, key);
			if (bDefault && keys.length) {
				cn.changeAttributeKeys(a.idAttr, xml.ATTR_REFMAP, csi.objectNew(keyDefault, value[keys[0]]));
			}
		},

		postProcessSuccess: function() {
			// summary: redraw view
			this.widget.redraw();
		}
	});
});